module.exports = __webpack_public_path__ + "img/m3.f006de2f.png";